import { createReducer } from 'redux-create-reducer'
import type { ClientLibrary } from 'types/client-library'
import {
  CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD,
  CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD_FAIL,
  CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
export type State = {
  error: Error | null | undefined
  loading: boolean
  loaded: boolean
  items: ClientLibrary[]
}
const initialState: State = {
  error: null,
  loading: false,
  loaded: false,
  items: [],
}
export const suggestedLibrariesReducer = createReducer<State, any>(
  initialState,
  {
    [CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD](state: State) {
      return { ...state, error: null, loaded: false, loading: true }
    },

    [CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD_SUCCESS](
      state: State,
      { results }: Record<string, any>,
    ) {
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        items: results || state.items,
      }
    },

    [CLIENT_LIBRARY_SUGGESTED_LIBRARIES_LOAD_FAIL](
      state: State,
      { error }: Record<string, any>,
    ) {
      return { ...state, error, loaded: false, loading: false }
    },
  },
)
